import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Brand, { BrandHome } from '../common/Brand';
import LanguageSwitcher from '../common/LanguageSwitcher';
import { SimpleThemeToggle } from '../../contexts/ThemeContext';
import ConversationRibbon from '../common/ConversationRibbon';
import AccessGeometry from './AccessGeometry';

/** Shared presentation only: each screen retains its own token and auth flow. */
export default function AuthFrame({ children }: { children: ReactNode }) {
  const { t } = useTranslation('brand');
  return <div className="app-shell access-shell">
    <header className="portal-brandbar"><BrandHome /><div className="flex items-center gap-2"><LanguageSwitcher compact idPrefix="access-language" className="access-language" /><SimpleThemeToggle className="access-theme" /></div></header>
    <div className="access-content">
      <aside className="auth-scene access-artwork" aria-hidden="true"><ConversationRibbon /><AccessGeometry /><Brand artwork /><p>Where Conversations Become Credible Assessments.</p></aside>
      <div className="auth-form-frame access-form-frame">
        <ConversationRibbon className="access-frame-wave" />
        <section className="access-card panel-surface">
          {children}
          <Link to="/" className="mt-6 inline-block text-xs font-semibold text-[var(--mcq-accent)]">← {t('backHome')}</Link>
        </section>
      </div>
    </div>
  </div>;
}
